<p>payment-callback works!</p>
